import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useGetThreads } from '@/api/queries/useGetThreads';
import formatDate from '@/helpers/formatDate';
import { Icon } from '@/new/components/icon';

export function RecentActivity({ allDocumentsSubsetId }: { allDocumentsSubsetId: string }) {
  const { matterId } = useParams();
  if (!matterId) return;

  // TODO: Implement proper recent activity logic
  const { data: threads } = useGetThreads(matterId);
  const recentThreads = threads?.slice(0, 5) ?? [];

  return (
    <div className="rounded-md border border-gray-200 bg-white p-4">
      <div className="mb-2 flex items-center gap-2">
        <Icon className="lucide--activity text-base text-gray-500" />
        <h2 className="font-serif text-lg font-semibold text-gray-900">Recent Activity</h2>
      </div>
      <div className="flex flex-col gap-2">
        {recentThreads.length > 0 ? (
          recentThreads.map((thread) => (
            <Link key={thread.id} to={`/matters/${matterId}/subsets/${allDocumentsSubsetId}/kim/${thread.id}`}>
              <div className="group rounded-md border border-gray-100 bg-white p-2 transition-colors hover:bg-gray-50">
                <div className="mb-1 flex items-center justify-between gap-2">
                  <div className="flex min-w-0 items-center gap-2">
                    <Icon className="lucide--message-circle-question mt-0.5 text-xs text-gray-500" />
                    <p className="line-clamp-1 text-sm text-gray-900">Kim Question: {thread.name}</p>
                  </div>
                  <Icon className="lucide--chevron-right hidden text-gray-400 group-hover:block" />
                </div>
                <p className="ml-5 text-xs text-gray-500">{formatDate(thread.createdDate)}</p>
              </div>
            </Link>
          ))
        ) : (
          <div className="py-6 text-center">
            <Icon className="lucide--inbox mx-auto mb-2 text-2xl text-gray-400" />
            <p className="text-sm text-gray-500">No recent activity</p>
          </div>
        )}
      </div>
    </div>
  );
}
